import type { FC, ReactNode } from 'react'

import Head from 'next/head'

interface JsonLdProps {
    id: string
    data: Record<string, unknown>
}

/** Structured data for search engines. The JSON is escaped so it can never close its own tag. */
export const JsonLd: FC<JsonLdProps> = ({ id, data }): ReactNode => {
    const json = JSON.stringify(data)
        .replace(/</g, '\\u003c')
        .replace(/>/g, '\\u003e')
        .replace(/&/g, '\\u0026')

    return (
        <Head>
            <script key={`jsonld-${id}`} type='application/ld+json' dangerouslySetInnerHTML={{ __html: json }} />
        </Head>
    )
}

export const absoluteUrl = (origin: string, value: string | null | undefined): string | undefined => {
    if (!value) return undefined
    if (/^https?:\/\//i.test(value)) return value

    return `${origin}${value.startsWith('/') ? '' : '/'}${value}`
}
